export default "__VITE_ASSET__Bs0Zi104__"